import {
    GET_ALL_ROLES,
    ADD_ROLE,
    EDIT_ROLE,
    DELETE_ROLE
} from '../actions/RoleActions'

const initialState = {
    data: [],
    allRoles: [],
    latestUpdate: '',
    loading: false,
    error: '',
}

const RoleReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_ROLE: {
            let tempArray = Object.assign({}, state.allRoles)
            tempArray.rows = [action.payload, ...state.allRoles.rows]
            return {
                ...state,
                allRoles: tempArray,
            }
        }
        case EDIT_ROLE: {
            let tempArray = Object.assign({}, state.allRoles)
            let target = tempArray.rows.findIndex(item => {return item.id == action.payload.id})
            tempArray.rows[target] = action.payload            
            return {
                ...state,
                allRoles: tempArray,
            }
        }
        case DELETE_ROLE: {
            let tempArray = Object.assign({}, state.allRoles)
            let newArray = tempArray.rows.filter(item => {return item.id !== action.payload})
            tempArray.rows = newArray            
            return {
                ...state,
                allRoles: tempArray,
            }
        }
        case GET_ALL_ROLES: {
            return {
                ...state,
                allRoles: action.payload,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default RoleReducer
